import { defineStore } from 'pinia'

export const useCarStore = defineStore('carStore', {
  state: () => ({
    car: null
  })
})
